export default __webpack_public_path__ + "static/media/Intermedium.e004580e.ttf";